module.exports = "<nominas-nomina-deducciones-detallado\r\n    id-nomina=\"$ctrl.idNomina\"\r\n    id-empresa=\"$ctrl.idEmpresa\"></nominas-nomina-deducciones-detallado>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/nomina/components/deducciones/template.html
// module id = 1192
// module chunks = 0